<template>
	<div class="status-tag">
		<span class="dot" :class="type" :style="{ backgroundColor: color }"></span>
		<span class="label">
			{{ text }}
		</span>
	</div>
</template>

<script>
/**
 * 状态小圆点标签组件
 * @param {String} type - 类型 success | warning | danger | info | primary
 * @param {String} color - 颜色，优先级高于 type，支持 rgb、rgba、#、hsl、hsla
 * @param {String} text - 文本
 */

export default {
	name: "StatusTag",
	props: {
		type: {
			type: String,
			default: "success"
		},
		color: {
			type: String
		},
		text: {
			type: String
		}
	}
};
</script>

<style lang="scss" scoped>
.status-tag {
	display: inline-flex;
	align-items: center;

	.dot {
		width: 6px;
		height: 6px;
		border-radius: 50%;
		margin-right: 6px;

		&.success {
			background-color: $success-color;
		}

		&.warning {
			background-color: $warning-color;
		}

		&.danger {
			background-color: $danger-color;
		}

		&.info {
			background-color: $info-color;
		}

		&.primary {
			background-color: $primary-color;
		}
	}

	.label {
		font-weight: 400;
		font-size: 12px;
		color: #31363f;
		line-height: 20px;
	}
}
</style>
